import React,{useState,useEffect,useRef} from "react";

  import { useRouteMatch,Switch, Route ,Link} from "react-router-dom";
import { useHistory,} from "react-router-dom";

import person1WhatYouWillDo2 from "../../../img/person1WhatYouWillDo2.svg";

import contentMan from "../../../img/contentMan.svg";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {X,Plus ,Star,BookmarkPlus,Phone,Check,Video,MonitorPlay,BookOpenCheck,
  TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,Aperture,Blocks,CalendarCog,Timer,AudioLines,
  FolderHeart, Forward,Earth,ListChecks,Gift,Settings,BetweenHorizontalStart,
  ImagePlay,Film,AlarmSmoke,BellElectric,CircleCheck,LayoutGrid ,CornerDownRight,BotMessageSquare,ChevronUp,ChevronDown,
  GripHorizontal,
  CopyPlus,
  Bookmark,
  Pencil,
  Trash2,
  Recycle,
  Play,
  Minus,
  ListFilter,
  ListCollapse,
  ListMusic,
  LayoutPanelTop,
  LayoutPanelLeft,
  ImageUp} from 'lucide-react';import Snackbar from "../../../../Snackbar";
import CreateSubCoursePopUp from "./CreateSubCoursePopUp";
import ContentFolderCard from "../ContentFolderCard";
import { createNewSubCourse, getAllSubCoursesByCourseId, reArrangeSubCourses } from "../../../../store/actions/CreateContent/OrganizeAPI/SubCoursesAPIs";
import FolderFilterCardTwo from "../FolderFilterCardTwo";
import FolderFilterCardThree from "../FolderFilterCardTwoThree";
import FolderFilterCard from "../FolderFilterCard";
import MilestonePanel from "./MilestonePanel";
import AreYouSurePopUp from "../ContentPopUp/AreYouSurePopUp";

const SubCoursesPanel =({selectCoursePopUp})=>{

     const dispatch = useDispatch();
         const user = useSelector((state)=>state?.user?.user);
               const [activeFilterOne, setActiveFilterOne] =useState(true);
                       const [activeFilterTwo, setActiveFilterTwo] =useState(true);
                       const [activeFilterThree, setActiveFilterThree] =useState(false);
                       const [activeFilterFour, setActiveFilterFour] =useState(false);
                       const [activeFilterASC, setActiveFilterASC] =useState(true);
                       const [activeFilterDESC, setActiveFilterDESC] =useState(false);
                       const [openSubCourseInfoPopUp, setOpenSubCourseInfoPopUp] =useState(false);
                       
         const [snackbarVisible, setSnackbarVisible] = useState(false);
                          const [snackbarColor, setSnackbarColor] = useState("#958FDA");
                          const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
                    
                                  const mainMenuStatus = useSelector((state)=>state?.app?.mainMenuStatus);
                       const showSnackbar = () => {
                         setSnackbarVisible(true);
                       };
                      
                       const hideSnackbar = () => {
                         setSnackbarVisible(false);
                       };
                 
                 
                            
                            
                         
                        const [animate, setAnimate] = useState(false);
          
           const [loader , setLoader] =useState({status:true});
    const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
        {
          
          dispatch({type: "CURSOR",payload:true  });
      
          dispatch({type: "CURSORTEXT",payload:CursorText})
          dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
          dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
        }
         
        const handleMouseLeave = () => {
          
          dispatch({type: "CURSOR",payload:false})
      
          dispatch({type: "CURSORTEXT",payload:""})
      
          dispatch({type: "CURSORTEXTBG",payload:""})
          dispatch({type: "CURSORTEXTCOLOR",payload:""})
        
      
      }
      const [openAppDesignPopUp,setopenAppDesignPopUp]  = useState(false);
      const [openAppDesignPopUpInnerContent,setopenAppDesignPopUpInnerContent]  = useState("appThemes");

      
const token = useSelector((state)=>state?.course?.course?.token);
       const currentToken = useSelector((state)=>state?.user?.user?.token);
       const user_email = useSelector((state)=>state?.user?.user?.user_email
      );
      
      const postIdCourse = useSelector((state)=>state?.course?.course?.postId);
      
      const courseData = useSelector((state)=>state?.course?.course);
      
      const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
     
        const appId = useSelector((state)=>state?.app?.app?.ID);
        const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);
          
           const [visibility,setVisibility] =useState("public");
           const [orderBy,setOrderBy] =useState("ASC");
           const [itemArr, setItemArr] = useState([]);
           const [itemReorderArr, setItemReorderArr] = useState([]);
           const [itemId, setItemId] = useState("");
           const [deleteItemPopUp, setDeleteItemPopUp] = useState(false);
           const [itemArrLoading, setItemArrLoading] = useState([{},{},{}]);
           const [openContentInFolder, setOpenContentInFolder] = useState("");
           const [openMilestoneForSubCourse, setOpenMilestoneForSubCourse] = useState("");
           const [createNewMileStone, setCreateNewMileStone] = useState(false);
           
 const [subCourseItem ,setSubCourseItem] =useState({});
 const updateItemData = (ID, newData) => {
  const updatedItems = itemArr.map(item =>
    item?.ID === ID ? { ...item, Name :newData?.Name , Description :newData?.Description
        , Thumbnail :newData?.Thumbnail,DemoVideos:newData?.DemoVideos,WhatWillULearn:newData?.WhatWillULearn,Prerequisite:newData?.Prerequisite
        ,TargetAudience:newData?.TargetAudience,SkillEarned:newData?.SkillEarned,JobScope:newData?.JobScope,Highlights:newData?.Highlights,FAQs:newData?.FAQs
    } : item
  
  ); 
  setSubCourseItem(newData);
 // console.log(updatedItems)
  setItemArr(updatedItems);
};
const sendBackSubCourse = (subCourse) => {
  const updatedItems = [...itemArr, subCourse]
  const updatedItemsMenuorder = [...itemReorderArr, {ID:subCourse?.ID,menuOrder:subCourse?.menuOrder}]
  setItemReorderArr( updatedItemsMenuorder);
 // console.log(updatedItems)
  setItemArr(updatedItems);
};

      useEffect((e)=>{
      
    fireGetAllSubCoursesByCourse();
    setOpenMilestoneForSubCourse("");
        },[visibility,orderBy,postIdCourse]);
  const fireGetAllSubCoursesByCourse=()=>{
          setItemArr([])
         
        
                
          // if(visibility=='public'){setActiveFilterTwo(true)}
          // if(openAppDesignPopUp){setActiveFilterTwo(true);setVisibility('public');}
          
        
          setItemArrLoading([{},{},{}])
        // Popup When Course is not selected
          if(courseData){}else{selectCoursePopUp(true);}
        
        setLoader({status:true});
            // console.log({
            //     token:AppToken,courseId:postIdCourse ,userEmail:user_email?user_email:"",currentToken:currentToken?currentToken:"",
            //     appToken:AppToken,visibility:visibility,orderBy:orderBy
            //     });
              const apiData = dispatch(getAllSubCoursesByCourseId({
                token:AppToken,courseId:postIdCourse ,userEmail:user_email?user_email:"",currentToken:currentToken?currentToken:"",
                appToken:AppToken,visibility:visibility,orderBy:orderBy,appId:appId,appAllottedToken:appAllottedToken
                }));
              /* get response as Promise   */
              apiData.then(response => {
                // console.log(response)
        
                if(response){
                 
                  if(response){
                setResponseMessage(response?.message);
                setSnackbarColor("rgba(144, 202, 249,1)");
              
                if(response?.subCourses)  {setItemArr(response?.subCourses); 
        
                  const reorderArray = response?.subCourses.map(item => ({
                    ID: item.ID,
                    menuOrder: item.menuOrder
                }));
                setItemReorderArr(reorderArray);
                //  console.log(reorderArray)
               
                }else{setItemArr([]);};
                setItemArrLoading([]);
            setLoader({status:false});
            
            // setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
            },1000)
               }else{
            //     setResponseMessage("Something Went Wrong...");
                  
            //     setSnackbarColor("#958FDA");
            //   //  selectCoursePopUp(true);
                
                 
            // setLoader({status:false});
            // setItemArrLoading([{},{},{}]);
            setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
             
               
            },3000)
               }
                  
                // dispatch({
                //   type: "UPDATE_APP_TOKEN",
                  
                //   payload:response?.course?.AppToken
                // });  
              //  console.log(response?.course);
             
               // 
               if(response?.logout){
                // pop up response?.logoutInfo
                //console.log(response?.logoutInfo)
            
                setResponseMessage("You are Logged Out!!!");
                  
                setSnackbarColor("#958FDA");
               selectCoursePopUp(true);
                
                 
            setLoader({status:false});
            
            setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
             
               
            },3000)
                setTimeout(()=>{
                  dispatch({type:"LOGOUT"});
            
                },3000)
                
              }
            /* resetting Login input Fields */
            
                }else{
                  setResponseMessage("Something Went Wrong...");
                  
                  setSnackbarColor("#958FDA");
                 selectCoursePopUp(true);
                 setItemArrLoading([{},{},{}]);
                   
              setLoader({status:false});
              
              setSnackbarVisible(true);
              setTimeout(()=>{
                
                setSnackbarVisible(false);
               
                 
              },3000)    }
            
              }).catch(error => {
             
                //popup of error Info
                setResponseMessage("Something Went Wrong...");
                  
                setSnackbarColor("#958FDA");
               selectCoursePopUp(true);
                
                 
            setLoader({status:false});
            
            setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
             
               
            },3000)
                console.error(error);
              });
         }

         const handleReArrangeSubCourse =(reorderedItemsArray)=>{
        //  console.log({
        //      token:AppToken,courseId:postIdCourse ,userEmail:user_email?user_email:"",currentToken:currentToken?currentToken:"",
        //      appToken:AppToken,menuOrder:JSON.stringify(reorderedItemsArray),orderBy:orderBy
        //      })
         
         
           const apiData = dispatch(reArrangeSubCourses({
             token:AppToken,courseId:postIdCourse ,userEmail:user_email?user_email:"",currentToken:currentToken?currentToken:"",
             appToken:AppToken,menuOrder:JSON.stringify(reorderedItemsArray),orderBy:orderBy,appId:appId,appAllottedToken:appAllottedToken
             }));
           /* get response as Promise   */
           apiData.then(response => {
            //  console.log(response)
         
          
              
               if(response){
                 
           // setSnackbarVisible(true);
             setResponseMessage("Saved Successfully!!!");
             setSnackbarColor("rgba(144, 202, 249,1)");
           
            
         setLoader({status:false});
         
         setTimeout(()=>{
           
           setSnackbarVisible(false);
         },1000)
            }else{
         
         setSnackbarVisible(true);
         setTimeout(()=>{
           
           setSnackbarVisible(false);
          
            
         },3000)
            }
               
             
            if(response?.logout){
             // pop up response?.logoutInfo
             //console.log(response?.logoutInfo)
         
             setResponseMessage("You are Logged Out!!!");
               
             setSnackbarColor("#958FDA");
            selectCoursePopUp(true);
             
              
         setLoader({status:false});
         
         setSnackbarVisible(true);
         setTimeout(()=>{
           
           setSnackbarVisible(false);
          
            
         },3000)
             setTimeout(()=>{
               dispatch({type:"LOGOUT"});
         
             },3000)
             
           }
         
         
            
         
           }).catch(error => {
          
             //popup of error Info
             setResponseMessage("Something Went Wrong...");
               
             setSnackbarColor("#958FDA");
             
         setLoader({status:false});
         
         setSnackbarVisible(true);
         setTimeout(()=>{
           
           setSnackbarVisible(false);
          
            
         },3000)
             console.error(error);
           });
         }

         
         const handleDeleteSubCourse=(val,subCourseID)=>{
           let editType=val;
             
           setLoader({status:true});
         
                 const apiData = dispatch( createNewSubCourse({
                  token:token,courseId:postIdCourse ,postParent:postIdCourse ,userEmail:user_email?user_email:null,
                  currentToken:currentToken?currentToken:null,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken,
                  editType:editType,postId:subCourseID,menuOrder:1}));
              
             /* get response as Promise   */
             apiData.then(response => {
               if(response){
         
                 console.log(response)
                 if(response?.subCourse){
               setResponseMessage(response?.message);
               setSnackbarColor("rgba(144, 202, 249,1)");
             
                
           setLoader({status:false});
           
           setSnackbarVisible(true);
           setTimeout(()=>{
             
             setSnackbarVisible(false);
            
            if(val=="deletesubCourse"){
             // setActiveFilterTwo(false);;setActiveFilterThree(true);
             const removedItems = itemArr.filter(item => item?.ID !== response?.subCourse?.ID);
             setItemArr(removedItems);
            } 
             if(val=="restoresubCourse"){
               // setActiveFilterTwo(true);;setActiveFilterThree(false);
               const removedItems = itemArr.filter(item => item?.ID !== response?.subCourse?.ID);
             setItemArr(removedItems);
             }
             setSubCourseItem({});
             setOpenSubCourseInfoPopUp(false)
           },1000)
              }else{
               setResponseMessage("Something Went Wrong...");
                 
               setSnackbarColor("#958FDA");
            
                
           setLoader({status:false});
           
           setSnackbarVisible(true);
           setTimeout(()=>{
             
             setSnackbarVisible(false);
            
              
           },3000)
              }
                 
              
              if(response?.logout){
              
               setResponseMessage("You are Logged Out!!!");
                 
               setSnackbarColor("#958FDA");
            
                
           setLoader({status:false});
           
           setSnackbarVisible(true);
           setTimeout(()=>{
             
             setSnackbarVisible(false);
            
              
           },3000)
               setTimeout(()=>{
                 dispatch({type:"LOGOUT"});
           
               },3000)
               
             }
           /* resetting Login input Fields */
           
               }else{
                 setResponseMessage("Something Went Wrong...");
                 
                 setSnackbarColor("#958FDA");
              
                  
             setLoader({status:false});
             
             setSnackbarVisible(true);
             setTimeout(()=>{
               
               setSnackbarVisible(false);
              
                
             },3000)    }
           
             }).catch(error => {
            
               //popup of error Info
               setResponseMessage("Something Went Wrong...");
                 
               setSnackbarColor("#958FDA");
            
                
           setLoader({status:false});
           
           setSnackbarVisible(true);
           setTimeout(()=>{
             
             setSnackbarVisible(false);
            
              
           },3000)
               console.error(error);
             });
            
             }
         
         const flattenedData = itemArr!=[]?Object.values(itemArr):'';

         const flattenedDataLoading = itemArrLoading!=[]?Object.values(itemArrLoading):'';
 
 const [draggedIndex, setDraggedIndex] = useState('');
 const [hoveredDropZone, setHoveredDropZone] = useState(null); // Track hovered drop zone
 const [selectedItemIndex, setSelectedItemIndex] = useState(null); // Track hovered drop zone
 
 const handleDragStart = (e, index) => {
   
   e.dataTransfer.effectAllowed = 'move';
   e.dataTransfer.setData("dragIndex", index);
   
 };
 
 const handleDrop = (e, dropIndex) => {
   const dragIndex = e.dataTransfer.getData("dragIndex");
   if (dragIndex === dropIndex) return;
 
   const updatedItems = [...itemArr];
   const [draggedItem] = updatedItems.splice(dragIndex, 1);
   updatedItems.splice(dropIndex, 0, draggedItem);
 
   const reorderedItems = updatedItems.map((item, index) => ({
     ...item,
     ID: item.ID,
     menuOrder:index+1
   }));
   const updatedItemsReorder = [...itemReorderArr];
   const [draggedItemReorder] = updatedItemsReorder.splice(dragIndex, 1);
   updatedItemsReorder.splice(dropIndex, 0, draggedItemReorder);
 
 
   setItemArr(reorderedItems);
 
   const reorderedItemsReorder = updatedItemsReorder.map((item, index) => ({
     ...item,
     ID: item.ID,
     menuOrder:index+1
   }));
 
 
//  console.log(reorderedItemsReorder)
   setItemReorderArr(reorderedItemsReorder);
   
   setTimeout(()=>{handleReArrangeSubCourse(reorderedItemsReorder);},1000)
   // setTimeout(()=>{setReorderFolderPopUp(true);},1000)
   // pop up For Saving This Order . Send Array Json To Backend
   // console.log(itemReorderArr)
   setDraggedIndex('');
   setHoveredDropZone(null); // Reset hovered drop zone
 };
 
 const handleDragOver = (e, index) => {
   e.preventDefault();
    // Set the hovered drop zone
 };
 
 const handleDragEnd = () => {
   setDraggedIndex('');
   setHoveredDropZone(null); // Clear hovered drop zone
 };
    



 
    return (<>
        {snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor} onClose={hideSnackbar} />
      )}
        <div  align="left" className=" " style={{background:"#ffffff",borderRadius:"25px",overflow:"hidden"}}> 
        {openMilestoneForSubCourse==""?<div className="contentPageScroller" style={{}} > 
        <div className="gridForFolderFilter">
<FolderFilterCard   activeCard={activeFilterOne}   icon={6} title ="+ New " onClickPopup={()=>{
    setActiveFilterOne(true);setActiveFilterTwo(true);;setActiveFilterThree(false);setVisibility('public'); 
    setSubCourseItem(null);    setopenAppDesignPopUp(true);setopenAppDesignPopUpInnerContent("createFolder");
} }  /> 
<FolderFilterCardTwo   activeCard={activeFilterTwo}  icon={6} title ="Show All" onClickPopup={()=>{setVisibility('public');
  setActiveFilterTwo(true);;setActiveFilterThree(false);setActiveFilterFour(false); 
} }  />
<FolderFilterCardTwo   activeCard={activeFilterThree}  icon={6} title ="Show Deleted" onClickPopup={()=>{setVisibility('trash');
   setActiveFilterTwo(false);;setActiveFilterThree(true);setActiveFilterFour(false); 
} }  />
<FolderFilterCardThree   activeCard={activeFilterASC}  icon={6} title ="ASC" onClickPopup={()=>{
  setActiveFilterASC(true);setActiveFilterDESC(false); setOrderBy("ASC");
   
} }  /> 
<FolderFilterCardThree   activeCard={activeFilterDESC}  icon={6} title ="DESC" onClickPopup={()=>{ 
   setActiveFilterASC(false);setActiveFilterDESC(true);setOrderBy("DESC");
    
} }  /> 
{/* <FolderFilterCardTwo   activeCard={activeFilterFour}  icon={6} title ="Import" onClickPopup={()=>{} }  />  */}

 
</div>
<h3 align="center"> {flattenedData?.length?"Showing "  +(flattenedData?.length):flattenedDataLoading?"Searching ":"No"}
   {activeFilterTwo?" Sub Courses":activeFilterThree?" Deleted Sub Courses":""} 
  
  {activeFilterTwo&&activeFilterASC?" In Ascending Order  ":activeFilterTwo||activeFilterThree?" In Descending Order  ":""}
  for A Course " {courseData?.CourseName} "</h3>

        <div className="gridForShowTwoSubCourses" style={{alignContent:"center",textAlign:"center",gap:"10px",margin:"0px",
   
   transition: 'transform 2s ease, opacity 1s ease',
 }}>
            
        {flattenedDataLoading?.length==0?flattenedData?.length?flattenedData?.map((item, index) => 
        (<div  index={index} key={item?.ID}    >
{visibility=="public"?selectedItemIndex!==index?
<div
            className="drop-zone"
            onDragOver={(e) => {setHoveredDropZone(index);
              handleDragOver(e, index)
            }}
            onDrop={(e) => {handleDrop(e, index);setSelectedItemIndex(null);}}
          
            style={{
              height: hoveredDropZone === index ?'345px':"0px",position:hoveredDropZone === index ?'relative':"",left:"0px",right:"0px",
              backgroundColor: hoveredDropZone === index ? 'rgba(149, 143, 218,0.2) ' : 'transparent', // Change color on hover
              border: hoveredDropZone === index ? '2px dashed rgba(149, 143, 218,1) ' : 'transparent', // Change color on hover
              transition: 'background-color  0.3s ease',width:"95%",
              borderRadius: '10px',marginBottom:hoveredDropZone === index ?"10px":"0px"
             
            }}
          ></div>:"":""}
            <div

onDragOver={(e) => { if(selectedItemIndex!==index){setHoveredDropZone(index);
    handleDragOver(e, index)}
  }}
  onDrop={(e) => {if(selectedItemIndex!==index){handleDrop(e, index);setSelectedItemIndex(null);}}}

             draggable 
             onDragStart={(e) =>{ handleDragStart(e, index);
              setDraggedIndex(item.ID); setSelectedItemIndex(index);
             }}className={draggedIndex == item.ID?"posFixed":"posRelative"  }
             style={{background:"#fff", margin:"10px",marginTop:"15px",
                marginRight:"15px",position:"relative",borderRadius:"10px",overflow:"hidden",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.021)"}} 
          
              onDragEnd={handleDragEnd}
            >
{/* <div onClick={()=>{}}
           onMouseEnter={handleMouseEnter}
                     onMouseLeave={handleMouseLeave}  className="subCoursePlayBtn" style={{position:"absolute",
                      zIndex:"99", textAlign:"center" ,cursor:"pointer",
                      }}>
          <Play   strokeWidth={3}  size={30}  className="subCoursePlayBtnIcon"  color="#fff"/>
        </div> */}
       
        <div  style={{display:"flex",position:"absolute",top:"0px",cursor:"pointer",justifyContent:"space-between" ,width:"100%"}} 
          > 
          {/* <div  style={{height:"19.5px",
            zIndex:"9999", top:"0px",}} 
          className="product-tag-theme1">Tag 1 </div> */}
            <div   
          className="">
          {visibility=="public"?<GripHorizontal onClick={()=>{}}
           onMouseEnter={handleMouseEnter}
                     onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
           color="#666666" style={{padding:"10px",border:"2px solid #eeeeee",background:"#fafafa",margin:"5px",borderRadius:"5px",cursor:"pointer",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.021)"}}/>
           :""}
           </div>
            <div   
          className=""> <div   
          className="">
           {visibility=="public"?<Pencil  onClick={()=>{setVisibility('public');setActiveFilterTwo(true);;setActiveFilterThree(false);setActiveFilterFour(false); 
           setSubCourseItem(item); setopenAppDesignPopUp(true);setOpenContentInFolder("");setopenAppDesignPopUpInnerContent("createFolder");}}
            onMouseEnter={handleMouseEnter}
                      onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
           color="#666666" style={{padding:"10px",border:"2px solid #eeeeee",background:"#fafafa",margin:"5px",borderRadius:"5px",cursor:"pointer",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0381)"}}/>
         :<div></div> }
         
         </div>  <div   
          className=""> 
          {visibility=="public"?<Trash2 onClick={()=>{ setSubCourseItem(item);;setOpenContentInFolder("");setDeleteItemPopUp('deletesubCourse') ;
          }}
           onMouseEnter={handleMouseEnter}
                     onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
           color="#666666" style={{padding:"10px",border:"2px solid #eeeeee",background:"#fafafa",margin:"5px",borderRadius:"5px",cursor:"pointer",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0381)"}}/> 
           :<Recycle onClick={()=>{ setSubCourseItem(item);;setOpenContentInFolder("");setDeleteItemPopUp('restoresubCourse') ;
           }}
            onMouseEnter={handleMouseEnter}
                      onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
            color="#666666" style={{padding:"10px",border:"2px solid #eeeeee",background:"#fafafa",margin:"5px",borderRadius:"5px",cursor:"pointer",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0381)"}}/> 
          } 
           </div>
           </div>
           </div>
            
<div onClick={()=>{setOpenMilestoneForSubCourse(item)
          setCreateNewMileStone(false)
        }} style={{height:"150px",width:"100%",background:"#f1f1f1",display:"flex",justifyContent:"center",alignItems:"center"}}><ImageUp size={90} color={"#aaaaaa"} /></div>




        <div  className="" style={{padding:"10px",background:"",marginTop:"5px", display: "grid",
        gridTemplateColumns: "80% 20%"}}>
        <div  onClick={()=>{setOpenMilestoneForSubCourse(item)
          setCreateNewMileStone(false)
        }} className="ellipsisTitle" style={{}}>Sub-course #{item?.menuOrder} : {item?.Name}</div> 
        <div    align="right"
          className="">
          <Blocks onClick={()=>{setOpenSubCourseInfoPopUp(true);  setSubCourseItem(item);}}
           onMouseEnter={handleMouseEnter}
                     onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
           color="#ffffff" style={{padding:"10px",background:"#565283 ",marginTop:"-5px",borderRadius:"5px",cursor:"pointer",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0381)"}}/>
             
           </div>
        </div><div  className="" style={{padding:"10px",background:"",marginTop:"5px", display: "grid",
        gridTemplateColumns: "50% 50%"}}> 
<div onClick={()=>{setOpenMilestoneForSubCourse(item)
          setCreateNewMileStone(false)
        }} onMouseEnter={handleMouseEnter}
                     onMouseLeave={handleMouseLeave} style={{background:"#fff",color:"#565283",
                     padding:"10px",margin:"5px",borderRadius:"10px",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0621)"
                     ,cursor:"pointer"}}> Organize</div>
<div onClick={()=>{setOpenMilestoneForSubCourse(item)
          setCreateNewMileStone(true)
        }} onMouseEnter={handleMouseEnter}
                     onMouseLeave={handleMouseLeave} style={{background:"#565283",color:"#fff",padding:"10px",
                     margin:"5px",borderRadius:"10px",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.021)",cursor:"pointer"}}> +Add Milestone</div>
</div>
</div></div>)):"":""}
{flattenedDataLoading?flattenedDataLoading?.map((item, index) => 
        (<div  index={index} key={item?.ID} style={{background:"#fff", margin:"10px",marginTop:"15px",
        marginRight:"15px",position:"relative",borderRadius:"10px",overflow:"hidden",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.021)"}} >
   
   {/* <div onClick={()=>{}}
           onMouseEnter={handleMouseEnter}
                     onMouseLeave={handleMouseLeave}  className="subCoursePlayBtnLoading text-linetw" style={{}}>
          <Play strokeWidth={3}  size={30}  className="subCoursePlayBtnIcon"  color="#fff"/>
        </div> */}
        <div  style={{display:"flex",position:"absolute",top:"0px",cursor:"pointer",justifyContent:"space-between" ,width:"100%"}} 
          > 
         
            <div   
          className="">
          <div className="text-linetw" onClick={()=>{}}
           onMouseEnter={handleMouseEnter}
                     onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
         style={{padding:"15px",width:"15px",margin:"5px",borderRadius:"5px",cursor:"pointer"}}/>
           
           </div>
          <div   
          className="" style={{width:"60px"}}>
          <div onClick={()=>{}} className="text-linetw"
           onMouseEnter={handleMouseEnter}
                     onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
            style={{padding:"15px",width:"15px",margin:"5px",borderRadius:"5px",cursor:"pointer"}}></div>
           <div onClick={()=>{}} className="text-linetw"
           onMouseEnter={handleMouseEnter}
                     onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
            style={{padding:"15px",width:"15px",margin:"5px",borderRadius:"5px",cursor:"pointer"}}> </div> 
           
           </div>
           </div>
            
<div style={{height:"150px",width:"100%",background:"#f1f1f1",display:"flex",justifyContent:"center",alignItems:"center"}}><ImageUp size={90} color={"#aaaaaa"} /></div>





        <div  className="" style={{padding:"10px",background:"",marginTop:"5px", display: "grid",
        gridTemplateColumns: "85% 15%"}}>
        <div  className="ellipsisTitle" style={{}}></div> 
        <div    align="right"
          className="">
         <div onClick={()=>{}} className="text-linetw"
           onMouseEnter={handleMouseEnter}
                     onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
            style={{padding:"15px",width:"15px",margin:"5px",borderRadius:"5px",cursor:"pointer"}}> </div> 
           
           </div>
        </div><div  className="" style={{padding:"10px",background:"",marginTop:"5px", display: "grid",
        gridTemplateColumns: "40% 20% 40%"}}> 
<div className="text-linetw" style={{padding:"15px",margin:"5px",borderRadius:"10px",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0621)"}}> <div ></div></div>
<div className=""> </div><div className="text-linetw"  style={{padding:"15px",margin:"5px",borderRadius:"10px",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.021)"}}></div>
</div>
</div>)):""} 
          </div>

          {flattenedDataLoading?.length==0?flattenedData?.length?"": <div align="center"style={{margin:"15px",height:"140px",padding:"10px",borderRadius:"15px",background:"rgba(255,114,94,0.1)"}}><h3 style={{"textAlign":"center",
       
    }}> Opps... <span className="coloredTextV1">No Sub Course Found !!!</span>{activeFilterThree?" Deleted Sub-Courses Will Show Up Here..."
      :" Create A New Sub Course And Add Contents."}  </h3>
    <h5>
       </h5>
    </div>:""}
          </div>:<div align="left"  >
        
<MilestonePanel setOpenMilestoneForSubCourse={setOpenMilestoneForSubCourse} selectCoursePopUp={selectCoursePopUp} SubCourseData={openMilestoneForSubCourse} setCreateNewMileStone={createNewMileStone} />      
             



</div>}
        
{deleteItemPopUp=='deletesubCourse'?<AreYouSurePopUp loadingText="Deleting..."  title="Delete This SubCourse" type="deletesubCourse"
 closePopUp={()=>{setDeleteItemPopUp(false)}}
 onClickPopup={(type)=>{handleDeleteSubCourse(type,subCourseItem?.ID);setTimeout(()=>{setDeleteItemPopUp(false)},1000)
  }}/>:deleteItemPopUp=='restoresubCourse'?<AreYouSurePopUp loadingText="Restoring..." title="Restore This SubCourse" type="restoresubCourse" closePopUp={()=>{setDeleteItemPopUp(false)}} 
  onClickPopup={(type)=>{handleDeleteSubCourse(type,subCourseItem?.ID);setTimeout(()=>{setDeleteItemPopUp(false)},1000)
  }}/>:""} 


{openSubCourseInfoPopUp?<div><div className="selectThumbImgOuterAll" onClick={()=>{setOpenSubCourseInfoPopUp(false)}}
 onMouseEnter={handleMouseEnter}
 onMouseLeave={handleMouseLeave} 
style={{cursor:"pointer",zIndex:9999}}>
   </div>
 
   <div  className="ShowFoldersDoubleOuter" style={{zIndex:10000,background:"#ffffff"}}>
   <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  style={{width:"40px",height:"40px",cursor:"pointer",
        borderRadius:"50%",float:"right",margin:"10px",
      background:"#958FDA",zIndex:999999}} onClick={()=>setOpenSubCourseInfoPopUp(false)}   >
        <X  style={{padding:"9px",}} color="#fff" size={22}/></div> 
       
<div   className="subCourseInfoInnerContainer" style={{width:"100%"} }>
<div className=""

             style={{
                position:"relative",margin:"10px",marginTop:"50px",borderRadius:"10px",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.021)"}} 
          
             
            >
{/* <div onClick={()=>{}}
           onMouseEnter={handleMouseEnter}
                     onMouseLeave={handleMouseLeave}  className="subCoursePlayBtn" style={{position:"absolute",top:"90px",
                      zIndex:"9999", textAlign:"center" ,cursor:"pointer",
                      }}>
          <Play   strokeWidth={3}  size={30}  className="subCoursePlayBtnIcon"  color="#fff"/>
        </div> */}
       
        <div  style={{display:"flex",position:"absolute",top:"0px",cursor:"pointer",justifyContent:"space-between" ,width:"100%"}} 
          > 
           
            <div   
          className=""> <div   
          className="">
           {visibility=="public"?<Pencil  onClick={()=>{setVisibility('public');setActiveFilterTwo(true);;setActiveFilterThree(false);setActiveFilterFour(false); 
           setSubCourseItem(subCourseItem); setopenAppDesignPopUp(true);setOpenContentInFolder("");setopenAppDesignPopUpInnerContent("createFolder");}}
            onMouseEnter={handleMouseEnter}
                      onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
           color="#666666" style={{padding:"10px",border:"2px solid #eeeeee",background:"#fafafa",margin:"5px",borderRadius:"5px",cursor:"pointer",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0381)"}}/>
         :<div></div> }
         
         </div>  <div   
          className=""> 
          {visibility=="public"?<Trash2 onClick={()=>{ setSubCourseItem(subCourseItem);;setOpenContentInFolder("");setDeleteItemPopUp('deletesubCourse') ;
          }}
           onMouseEnter={handleMouseEnter}
                     onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
           color="#666666" style={{padding:"10px",border:"2px solid #eeeeee",background:"#fafafa",margin:"5px",borderRadius:"5px",cursor:"pointer",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0381)"}}/> 
           :<Recycle onClick={()=>{ setSubCourseItem(subCourseItem);;setOpenContentInFolder("");setDeleteItemPopUp('restoresubCourse') ;
           }}
            onMouseEnter={handleMouseEnter}
                      onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
            color="#666666" style={{padding:"10px",border:"2px solid #eeeeee",background:"#fafafa",margin:"5px",borderRadius:"5px",cursor:"pointer",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0381)"}}/> 
          } 
           </div>
           </div>
           </div>
<div style={{height:"150px",width:"100%",background:"#f1f1f1",display:"flex",justifyContent:"center",alignItems:"center"}}><ImageUp size={90} color={"#aaaaaa"} /></div>





        
        <div  align="center" className="" style={{padding:"10px",background:"",marginTop:"5px",background:"#ffffff", display: "flex",
        justifyContent:"space-between"}}> 
<div onClick={()=>{setOpenMilestoneForSubCourse(subCourseItem)
          setCreateNewMileStone(false);setOpenSubCourseInfoPopUp(false);
        }} onMouseEnter={handleMouseEnter}
                     onMouseLeave={handleMouseLeave} style={{background:"#fff",color:"#565283",
                     padding:"10px",margin:"5px",borderRadius:"10px",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0621)"
                     ,cursor:"pointer"}}> Show Milestones</div>
<div onClick={()=>{setOpenMilestoneForSubCourse(subCourseItem)
          setCreateNewMileStone(true);setOpenSubCourseInfoPopUp(false);
        }} onMouseEnter={handleMouseEnter}
                     onMouseLeave={handleMouseLeave} style={{background:"#565283",color:"#fff",padding:"10px",
                     margin:"5px",borderRadius:"10px",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.021)",cursor:"pointer"}}> +Add Milestone</div>
</div>
</div>
<div className="contentSubCourseScroller">
<div  className="" style={{padding:"10px",background:"",marginTop:"5px", display: "grid",
        gridTemplateColumns: "100%",}}>
        <div  className="theme1 " style={{fontSize:"28px",fontWeight:"999"}}>Sub-Course #{subCourseItem?.menuOrder} :{subCourseItem?.Name}</div> 
      
        </div>

        <div  className="" style={{padding:"10px",background:"",marginTop:"5px", display: "grid",
        gridTemplateColumns: "100%",}}>
        <div  className="theme1 " style={{fontSize:"14px"}}>{subCourseItem?.Description}</div> 
      
        </div>
<div className="theme1"  style={{margin:"10px",marginTop:"20px",overflow:"hidden",
  minHeight:"190px",borderRadius:"25px",background:"#f9f9f9",position:"relative"}}>
<div style={{position:"absolute",right:"0px",top:"0px",borderTopLeftRadius:"5px",
  borderBottomLeftRadius:"50px",background:"#EBF6FF"}}>
<img    className="" src={person1WhatYouWillDo2} 
        alt="selected Img"
   style={{cursor:"pointer",width:"100px"
    
   }}/>
</div>
<div className="theme1 courseContentTitleFont">What you'll learn</div>
<div className="theme1 ">
  
      <div  className="courseWhatWillearnIcon">
      <ListChecks strokeWidth={3} absoluteStrokeWidth  size={23}  color="#90CAF9"/> 
      <div className="theme1 "
 style={{fontSize:"14px",color:"#111",fontWeight:"500"}}> 
   This Course Includes Hands On Exercises Videos And Tests To Equip You With All Inportant Trends In Blender
 
      </div>
      </div><div  className="courseWhatWillearnIcon">
      <ListChecks strokeWidth={3} absoluteStrokeWidth  size={23}  color="#90CAF9"/> 
      <div className="theme1 "
 style={{fontSize:"14px",color:"#111",fontWeight:"500"}}> 
  This Course Includes Hands On Exercises Videos And Tests 
      </div>
      </div><div  className="courseWhatWillearnIcon">
      <ListChecks strokeWidth={3} absoluteStrokeWidth  size={23}  color="#90CAF9"/> 
      <div className="theme1 "
 style={{fontSize:"14px",color:"#111",fontWeight:"500"}}> 
  This Course Will Equip You With All Inportant Trends In Blender
      </div>
      </div>
</div>



  
  </div>

   <div className="theme1 gridForWhatsNextAfterYT5"  style={{marginTop:"20px",overflow:"hidden",
    minHeight:"190px",position:"relative"}}>
    <div style={{}}>
    <div style={{background:"rgba(255,114,94,0.051)",borderRadius:"15px",padding:"10px",margin:"5px"}} >
    <div className="theme1 grid2080Course"  style={{
    borderRadius:"25px",margin:"3px"}}>
    <div style={{background:"rgba(255,114,94,0.9)",width:"56px",height:"56px",borderRadius:"50%",padding:"0px"}} >
    <AlarmSmoke strokeWidth={4} absoluteStrokeWidth  size={40} style={{margin:"8px",marginTop:"10px"}} color="#fff" />  </div>
    <div   >
    </div></div>
  <div><div   >
      <div className="theme1"   style={{margin:"0px",fontSize:"26px",color:"rgba(255,114,94,0.9)",fontWeight:"800"}}>
        Skills </div>
   
   
    </div>
    
  {/* 
   <div className="theme1"  style={{fontSize:"16px",border:"1px solid rgba(144,202,249,0.9)",
   borderRadius:"5px",margin:"13px",textAlign:"center",height:"20px",background:"#fff"}}>
      <div className="theme1"  style={{margin:"0px",color:"rgba(144,202,249,0.9)"}}>Send As Gift</div>
      </div> */}
      </div>
    </div></div> <div style={{}}>
   
    <div style={{background:"rgba(144,202,249,0.09)",borderRadius:"15px",padding:"10px",margin:"5px"}} >
  
  <div><div   ><div className="theme1"   style={{margin:"0px",fontSize:"26px",color:"#222",fontWeight:"800"}}>
      Job Scope</div>


   <div > 
   <div   className="courseWhatWillearnIcon ">
        <ListMusic   strokeWidth={2} absoluteStrokeWidth  size={23}  color="rgba(123, 92, 167, 0.9)"/> 
        <div className="theme1 "
   style={{fontSize:"14px",color:"#111",fontWeight:"500"}}> 
     This Course Includes Hands On Exercises 
   
        </div>
        </div> <div   className="courseWhatWillearnIcon ">
        <ListMusic   strokeWidth={2} absoluteStrokeWidth  size={23}  color="rgba(123, 92, 167, 0.9)"/> 
        <div className="theme1 "
   style={{fontSize:"14px",color:"#111",fontWeight:"500"}}> 
     Tests To Equip You With All Inportant Trends In Blender
   
        </div>
        </div>
   </div>  
    </div></div>
    </div>
    </div>
  </div>
  <div className="theme1"  style={{marginTop:"10px",overflow:"hidden",
    minHeight:"190px",borderRadius:"25px",background:"#fff",position:"relative"}}>
   <div className="theme1 whatIncludesInSidebar courseContentTitleFont "  style={{
    borderRadius:"25px",margin:"3px"}}>
    
    <BellElectric  strokeWidth={4} absoluteStrokeWidth  size={47} style={{marginTop:"-10px"}} color="#9690da" />
    
    Highlights
    </div>
    
  
  <div className="theme1 " style={{
    margin:"5px",marginTop:"5px"}}>
    
        <div   className="courseWhatWillearnIcon ">
        <LayoutGrid   strokeWidth={2} absoluteStrokeWidth  size={23}  color="rgba(255,114,94,0.9)"/> 
        <div className="theme1 "
   style={{fontSize:"14px",color:"#111",fontWeight:"500"}}> 
     This Course Includes Hands On Exercises Videos And Tests To Equip You With All Inportant Trends In Blender
   
        </div>
        </div><div  className="courseWhatWillearnIcon">
        <LayoutGrid   strokeWidth={2} absoluteStrokeWidth  size={23}  color="rgba(255,114,94,0.9)"/> 
        <div className="theme1 "
   style={{fontSize:"14px",color:"#111",fontWeight:"500"}}> 
    This Course Includes Hands On Exercises Videos And Tests 
        </div>
        </div><div  className="courseWhatWillearnIcon">
        <LayoutGrid   strokeWidth={2} absoluteStrokeWidth  size={23}  color="rgba(255,114,94,0.9)"/> 
        <div className="theme1 "
   style={{fontSize:"14px",color:"#111",fontWeight:"500"}}> 
    This Course Will Equip You With All Inportant Trends In Blender
        </div>
        </div>
  </div>
  
  
  
    
    </div>


     <div className="theme1"  style={{margin:"10px",marginTop:"20px",overflow:"hidden",
  minHeight:"190px",borderRadius:"25px",background:"rgba(144, 202, 249,0.1)",position:"relative"}}>
<div style={{position:"absolute",right:"0px",top:"0px",borderTopLeftRadius:"5px",
  borderBottomLeftRadius:"50px",}}>

</div>

<div className=" gridForWhatsNextAfterYT5"  style={{marginTop:"20px",overflow:"hidden",
    minHeight:"190px",position:"relative"}}>

<div className=" ">
<div className="theme1 courseContentTitleFont">Target Audience</div>
      <div  className="courseWhatWillearnIcon">
      <ListFilter strokeWidth={3} absoluteStrokeWidth  size={23}  color="#90CAF9"/> 
      <div className="theme1 "
 style={{fontSize:"14px",color:"#111",fontWeight:"500"}}> 
   This Course Includes Hands On Exercises Videos And Tests To Equip You With All Inportant Trends In Blender
 
      </div>
      </div><div  className="courseWhatWillearnIcon">
      <ListFilter strokeWidth={3} absoluteStrokeWidth  size={23}  color="#90CAF9"/> 
      <div className="theme1 "
 style={{fontSize:"14px",color:"#111",fontWeight:"500"}}> 
  This Course Includes Hands On Exercises Videos And Tests 
      </div>
      </div><div  className="courseWhatWillearnIcon">
      <ListFilter strokeWidth={3} absoluteStrokeWidth  size={23}  color="#90CAF9"/> 
      <div className="theme1 "
 style={{fontSize:"14px",color:"#111",fontWeight:"500"}}> 
  This Course Will Equip You With All Inportant Trends In Blender
      </div>
      </div>
</div>

<div className="" style={{borderRadius:"25px",background:"#fff",position:"relative"}} >
   
<div className="theme1 courseContentTitleFont" >Prerequisite</div>
 
    
  
  <div className=" " style={{
    padding:"10px",marginTop:"5px"}}>
    
    <div   className="courseWhatWillearnIcon ">
        <LayoutPanelLeft   strokeWidth={2} absoluteStrokeWidth  size={23}  color="#222"/> 
        <div className="theme1 "
   style={{fontSize:"14px",color:"#222",fontWeight:"500"}}> 
     This Course Includes Hands On Exercises Videos And Tests To Equip You With All Inportant Trends In Blender
   
        </div>
        </div><div   className="courseWhatWillearnIcon ">
        <LayoutPanelLeft   strokeWidth={2} absoluteStrokeWidth  size={23}  color="#222"/> 
        <div className="theme1 "
   style={{fontSize:"14px",color:"#222",fontWeight:"500"}}> 
     This Course Includes Hands On Exercises Videos And Tests To Equip You With All Inportant Trends In Blender
   
        </div>
        </div>
  </div>
  
  
  
    
    </div>

  
    </div> 
    </div> 
<div className="theme1"  style={{marginTop:"20px",overflow:"hidden",
  minHeight:"190px",borderRadius:"25px",background:"#fff",position:"relative"}}>
<div className="theme1 whatIncludesInSidebar FAOuterTitle  "  style={{
  borderRadius:"25px",marginTop:"10px",fontWeight:"900",color:"#222"}}>
  
  <BotMessageSquare   strokeWidth={4} absoluteStrokeWidth  size={47} style={{marginTop:"-10px"}} color="#9690da" />
  
  FAQs
  </div>

<div className=" ">
  
<div className="outerFAQShadow">
<div  className="courseFAQActive" >
        <div className="theme1 FAQQuestionStyle"
 > 
 FAQ 1:  This Course Includes Hands On Exercises Videos And Tests 
 
      </div> 
      <div style={{background:"#fff",width:"40px",height:"40px",borderRadius:"50%"}}><Minus strokeWidth={3} absoluteStrokeWidth  size={29} style={{margin:"5px"}}  color="rgba(255,114,94,0.7)"/> </div>
      </div>

      
      <div  className="courseFAQItemInner">
      <CornerDownRight   strokeWidth={2} absoluteStrokeWidth  size={23}  color="rgba(255,114,94,0.7)"/> 
      <div className="theme1 "
 style={{fontSize:"13px",color:"#555",fontWeight:"500"}}> 
   This Course Includes Hands On Exercises Videos And Tests 
 
      </div>
      </div>
      <div  className="courseFAQItemInner">
      <CornerDownRight   strokeWidth={2} absoluteStrokeWidth  size={23}  color="rgba(255,114,94,0.7)"/> 
      <div className="theme1 "
 style={{fontSize:"13px",color:"#555",fontWeight:"500"}}> 
  This Course Includes Hands On Exercises Videos And Tests 
  This Course Includes Hands On Exercises Videos And Tests 
  This Course Includes Hands On Exercises Videos And Tests 
      </div>
      </div>
      <div  className="courseFAQItemInner">
      <CornerDownRight   strokeWidth={2} absoluteStrokeWidth  size={23}  color="rgba(255,114,94,0.7)"/> 
      <div className="theme1 "
 style={{fontSize:"13px",color:"#555",fontWeight:"500"}}> 
  This Course Will Equip You With All Inportant Trends In Blender
      </div>
      </div>
      </div>


<div className="outerFAQShadow">
      <div  className="courseFAQInActive">
        <div className="theme1 FAQQuestionStyle "
 style={{}}> 
 FAQ 2:  This Course Includes Hands On Exercises Videos And Tests 
 
      </div> 
      <div style={{background:"rgba(255,114,94,0.1)",width:"40px",height:"40px",borderRadius:"50%"}}><Plus strokeWidth={3} absoluteStrokeWidth  size={29} style={{margin:"5px"}}  color="rgba(255,114,94,0.7)"/> </div>
    
     
      </div>
     
</div>
      
<div className="outerFAQShadow">
      <div  className="courseFAQInActive">
        <div className="theme1 FAQQuestionStyle "
 style={{}}> 
 FAQ 3:  This Course Includes Hands On Exercises Videos And Tests 
 
      </div>
       <div style={{background:"rgba(255,114,94,0.1)",width:"40px",height:"40px",borderRadius:"50%"}}><Plus strokeWidth={3} absoluteStrokeWidth  size={29} style={{margin:"5px"}}  color="rgba(255,114,94,0.7)"/> </div>
    
     
      </div>
     
</div>
<div className="outerFAQShadow">
      <div  className="courseFAQInActive">
        <div className="theme1 FAQQuestionStyle "
 style={{}}> 
 FAQ 4:  This Course Includes Hands On Exercises Videos And Tests 
 
      </div> 
      <div style={{background:"rgba(255,114,94,0.1)",width:"40px",height:"40px",borderRadius:"50%"}}><Plus strokeWidth={3} absoluteStrokeWidth  size={29} style={{margin:"5px"}}  color="rgba(255,114,94,0.7)"/> </div>
    
     
      </div>
     
</div>

</div>

  </div>
</div>
   
   </div>
   </div>
   
   </div>:""}


              {openAppDesignPopUp?<div className="appDesignPopUp"  style={{zIndex:99999} }>
   <div   onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} style={{cursor:"pointer",}} onClick={()=>{setopenAppDesignPopUp()}} 
            className="appDesignPopUpOpacity"></div>
   <div   className="appDesignPopUpInner " style={{margin:'0px',
    overflowY: "auto",zIndex:9999999,background:"#f9f9f9"}}>
         
        <div className="userInfoLiner" style={{background:"#ffffff"}} >
        <div className="userInfoLinerInn" style={{background:"#ffffff"}}>
        
          <img  className="userInfoLinerPic"src={user?.profile_pic?user?.profile_pic:"https://img.freepik.com/free-vector/illustration-businessman_53876-5856.jpg"} alt={user?.profile_pic} />
           
      </div>  
      </div><div className="userInfoLinerName">
              {openAppDesignPopUpInnerContent=="createFolder"?
         <CreateSubCoursePopUp menuOrder={flattenedData?.length+1} sendBackSubCourse={(subCourse)=>{sendBackSubCourse(subCourse)}} changeItemData={(id,data)=>{updateItemData(id,data)} }  subCourseItem={subCourseItem} setopenAppDesignPopUp={setopenAppDesignPopUp} /> 
      :""}</div>
      </div>
      </div>:""}
      
    

        
        </div></>)
}
export default SubCoursesPanel;

